import styles from "./NevermindCancel.module.scss";

import { useTranslation } from "react-i18next";

import { PageContainer } from "@/modules/shared/components/PageContainer";

export const NevermindCancel = () => {
  const { t } = useTranslation();
  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("nevermindScreen.title")}</span>
        <span className={styles.description}>
          {t("nevermindScreen.description")}
        </span>
      </div>
    </PageContainer>
  );
};
